import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthService } from '../services/auth.service';

/** Blocks `client_view` users from staff-only routes. */
export const staffOnlyGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  if (auth.isClientView()) {
    return router.createUrlTree(['/client-view/access-restricted']);
  }
  return true;
};
